import React from "react";
import styled from "styled-components";
import { useTooltipStore } from "../../../store/useTooltipStore";

/**
 * Élément DOM unique du tooltip. À rendre une seule fois dans la page.
 * Les éléments qui veulent un tooltip utilisent le hook `useTip`.
 */
export const GlobalTooltip = () => {
    const { visible, text, x, y } = useTooltipStore();
    return (
        <Tip className={visible ? "show" : ""} style={{ left: x, top: y }}>
            {text}
        </Tip>
    );
};

/** Retourne les handlers souris à spreader sur n'importe quel élément (HTML ou SVG) */
export const useTip = () => {
    const show = useTooltipStore((s) => s.show);
    const move = useTooltipStore((s) => s.move);
    const hide = useTooltipStore((s) => s.hide);

    return (text) => {
        if (!text) return {};
        return {
            onMouseEnter: (e) => show(text, e.clientX, e.clientY - 12),
            onMouseMove: (e) => move(e.clientX, e.clientY - 12),
            onMouseLeave: hide,
        };
    };
};

const Tip = styled.div`
    position: fixed;
    background: var(--prh-card);
    color: var(--prh-muted);
    border: 1px solid var(--prh-violet-line);
    box-shadow: 0 4px 14px rgba(36, 36, 36, 0.14);
    font-size: 12px;
    font-weight: 400;
    padding: 5px 9px;
    border-radius: var(--prh-radius-sm);
    white-space: nowrap;
    pointer-events: none;
    z-index: 200;
    opacity: 0;
    transition: opacity 0.1s;
    transform: translate(-50%, -100%);
    &.show {
        opacity: 1;
    }
`;
